import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_DiagnosticAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_DiagnosticAssessment' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    <center>
                        <h3>
                            Georgia Health Partners, LLC
                        </h3>
                        <span>Diagnostic Assessment</span>
                        <h4>
                            U3 ONLY
                        </h4>

                    </center>

                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Identifying Information and Presenting Problem:</span>
                    <span className='small'>(include name, age, sex and mental status)</span>
                    <textarea id='txtIdentifyingInformationHPI' name='txtIdentifyingInformationHPI' className='add-only'></textarea>


                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Oppositional Symptoms:</span>


                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_1' name='rbIdentifying_1' className='add-only' value='Identifying_1' /> Defiance
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_2' name='rbIdentifying_2' className='add-only' value='Identifying_2' /> Not Following rules/directions
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_3' name='rbIdentifying_3' className='add-only' value='Identifying_3' /> Drugs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_4' name='rbIdentifying_4' className='add-only' value='Identifying_4' /> Alcohol
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_5' name='rbIdentifying_5' className='add-only' value='Identifying_5' /> Runaway
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_6' name='rbIdentifying_6' className='add-only' value='Identifying_6' /> Physical fights w/parents
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_7' name='rbIdentifying_7' className='add-only' value='Identifying_7' /> Promiscuity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_8' name='rbIdentifying_8' className='add-only' value='Identifying_8' /> Lies
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_9' name='rbIdentifying_9' className='add-only' value='Identifying_9' /> Stealing
                        </td>
                    </tr>
                    <tr>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_10' name='rbIdentifying_10' className='add-only' value='Identifying_10' /> Poor Grades
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_11' name='rbIdentifying_11' className='add-only' value='Identifying_11' /> School Disruptions
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbIdentifying_12' name='rbIdentifying_12' className='add-only' value='Identifying_12' />None Reported
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Depressive Symptoms:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_1' name='rbDepressive_1' className='add-only' value='Depressive_1' /> Depressed Mood
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_2' name='rbDepressive_2' className='add-only' value='Depressive_2' /> Sleep Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_3' name='rbDepressive_3' className='add-only' value='Depressive_3' /> Eating Problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_4' name='rbDepressive_4' className='add-only' value='Depressive_4' /> Poor Energy
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_5' name='rbDepressive_5' className='add-only' value='Depressive_5' /> Poor Concentration
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_6' name='rbDepressive_1' className='add-only' value='Depressive_6' /> Irritability
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_7' name='rbDepressive_2' className='add-only' value='Depressive_7' /> Guilt
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_8' name='rbDepressive_3' className='add-only' value='Depressive_8' /> Hopeless
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_9' name='rbDepressive_4' className='add-only' value='Depressive_9' /> Explosiveness
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_10' name='rbDepressive_5' className='add-only' value='Depressive_10' /> Anhedonia
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_11' name='rbDepressive_11' className='add-only' value='Depressive_11' /> Social Isolation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_12' name='rbDepressive_12' className='add-only' value='Depressive_12' /> SI,
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbDepressive_13' name='rbDepressive_13' className='add-only' value='Depressive_13' /> with intent
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Manic Symptoms:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbManic_1' name='rbManic_1' className='add-only' value='Manic_1' /> Racing thoughts
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbManic_2' name='rbManic_2' className='add-only' value='Manic_2' /> Decreased need for sleep
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbManic_3' name='rbManic_3' className='add-only' value='Manic_3' /> Increased goal directed activity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbManic_4' name='rbManic_4' className='add-only' value='Manic_4' /> Mood Swings
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbManic_5' name='rbManic_5' className='add-only' value='Manic_5' /> Euphoria
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbManic_6' name='rbManic_6' className='add-only' value='Manic_6' /> Pressured Speech
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ADHD Symptoms:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_1' name='rbSymptoms_1' className='add-only' value='Symptoms_1' /> Losing things
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_2' name='rbSymptoms_2' className='add-only' value='Symptoms_2' /> Forgetting things
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_3' name='rbSymptoms_3' className='add-only' value='Symptoms_3' /> Impulsivity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_4' name='rbSymptoms_4' className='add-only' value='Symptoms_4' /> Problems finishing tasks
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_5' name='rbSymptoms_5' className='add-only' value='Symptoms_5' /> Blurting out
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_6' name='rbSymptoms_6' className='add-only' value='Symptoms_6' /> Interrupting
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_7' name='rbSymptoms_7' className='add-only' value='Symptoms_7' /> Impatience
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_8' name='rbSymptoms_8' className='add-only' value='Symptoms_8' /> Inattentiveness
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_9' name='rbSymptoms_9' className='add-only' value='Symptoms_9' /> Distractibility
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_10' name='rbSymptoms_10' className='add-only' value='Symptoms_10' /> Hyperactivity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_11' name='rbSymptoms_11' className='add-only' value='Symptoms_11' /> Fidgetiness
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbSymptoms_12' name='rbSymptoms_12' className='add-only' value='Symptoms_12' /> Problems sitting still
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PTSD Symptoms:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPtsd_1' name='rbPtsd_1' className='add-only' value='Ptsd_1' /> Nightmares
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPtsd_2' name='rbPtsd_2' className='add-only' value='Ptsd_2' /> Flashbacks
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPtsd_3' name='rbPtsd_3' className='add-only' value='Ptsd_3' /> Dissociation
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPtsd_4' name='rbPtsd_4' className='add-only' value='Ptsd_4' /> Startle
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPtsd_5' name='rbPtsd_5' className='add-only' value='Ptsd_5' /> Avoidance
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='checkbox' id='rbPtsd_6' name='rbPtsd_6' className='add-only' value='Ptsd_6' /> Intrusive thoughts
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Violence:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbViolence_1' name='rbViolence_1' className='add-only' value='Violence_1' /> Fighting
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbViolence_2' name='rbViolence_2' className='add-only' value='Violence_2' /> HI
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Psychosis:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPsychosis_1' name='rbPsychosis_1' className='add-only' value='Psychosis_1' /> AH
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPsychosis_2' name='rbPsychosis_2' className='add-only' value='Psychosis_2' /> VH
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPsychosis_3' name='rbPsychosis_3' className='add-only' value='Psychosis_3' /> Cutting
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>PMHx:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Allergies:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'> FHx:  </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPmhx' name='txtPmhx' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAllergies' name='txtAllergies' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFhx' name='txtFhx' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Meds:</span>
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMeds' name='txtMeds' className='add-only' />
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Previous Psychiatric History: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPsychiatric_1' name='rbPsychosis_1' className='add-only' value='Psychiatric_1' /> Hospitalized
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPsychiatric_2' name='rbPsychosis_2' className='add-only' value='Psychiatric_2' /> Outpatient
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Previous Psychiatric Meds: </span>
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPreviousPsychiatricMeds' name='txtPreviousPsychiatricMeds' className='add-only' />
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Social History:  </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbSocial_1' name='rbSocial_1' className='add-only' value='Social_1' /> Parent divorced
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbSocial_2' name='rbSocial_2' className='add-only' value='Social_2' /> Father involved
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Pt lives with:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_1' name='rbPtsd_1' className='add-only' value='Lives_1' /> Mother
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_2' name='rbPtsd_2' className='add-only' value='Lives_2' /> Father
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_3' name='rbPtsd_3' className='add-only' value='Lives_3' /> Stepfather
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_4' name='rbPtsd_4' className='add-only' value='Lives_4' /> Stepmother
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_5' name='rbPtsd_5' className='add-only' value='Lives_5' /> Sister
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_6' name='rbLives_6' className='add-only' value='Lives_6' /> Brother
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_7' name='rbLives_7' className='add-only' value='Lives_7' /> Stepsister
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_8' name='rbLives_8' className='add-only' value='Lives_8' /> Stepbrother
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_9' name='rbLives_9' className='add-only' value='Lives_9' /> Grandmother
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_10' name='rbLives_10' className='add-only' value='Lives_10' /> Grandfather
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_11' name='rbLives_11' className='add-only' value='Lives_11' /> Foster Mother
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_12' name='rbLives_12' className='add-only' value='Lives_12' /> Foster Father
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_13' name='rbLives_13' className='add-only' value='Lives_13' /> Foster siblings
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_14' name='rbLives_14' className='add-only' value='Lives_14' /> Physical abuse
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_15' name='rbLives_15' className='add-only' value='Lives_15' /> Reported
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_16' name='rbLives_16' className='add-only' value='Lives_16' /> Sexual abuse
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLives_17' name='rbLives_17' className='add-only' value='Lives_17' /> Reported
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>School Hx: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            Grade Level:
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtGradeLevel' name='txtGradeLevel' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbSchool_1' name='rbSchool_1' className='add-only' value='School_1' /> Repeat grade
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbSchool_2' name='rbSchool_2' className='add-only' value='School_2' /> Special classes
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbSchool_3' name='rbSchool_3' className='add-only' value='School_3' /> Suspensions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbSchool_4' name='rbSchool_4' className='add-only' value='School_4' /> Expulsion
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Substance Abuse Hx: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAbuse_1' name='rbAbuse_1' className='add-only' value='Abuse_1' /> Marijuana
                        </td>
                        <td className='w-100'>
                            <input type='checkbox' id='rbAbuse_2' name='rbAbuse_2' className='add-only' value='Abuse_2' /> ETOH
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='rbAbuse_3' name='rbAbuse_3' className='add-only' value='Abuse_3' /> Crystal Methamphetamine
                        </td>
                        <td className='w-100'>
                            <input type='checkbox' id='rbAbuse_4' name='rbAbuse_4' className='add-only' value='Abuse_4' /> MDMA
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAbuse_5' name='rbAbuse_5' className='add-only' value='Abuse_5' /> Stimulants
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAbuse_6' name='rbAbuse_6' className='add-only' value='Abuse_6' /> PCP
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAbuse_7' name='rbAbuse_7' className='add-only' value='Abuse_7' /> Ketamine
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAbuse_8' name='rbAbuse_8' className='add-only' value='Abuse_8' /> Heroin
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAbuse_9' name='rbAbuse_9' className='add-only' value='Abuse_9' /> Cocaine
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAbuse_10' name='rbAbuse_10' className='add-only' value='Abuse_10' /> LSD
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAbuse_11' name='rbAbuse_11' className='add-only' value='Abuse_11' /> Inhalants
                        </td>
                        <td className='w-100'>
                            <input type='checkbox' id='rbAbuse_12' name='rbAbuse_12' className='add-only' value='Abuse_12' /> Hashish
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAbuse_13' name='rbAbuse_13' className='add-only' value='Abuse_13' /> Mushrooms
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='rbAbuse_14' name='rbAbuse_14' className='add-only' value='Abuse_14' /> Benzodiazepines
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAbuse_15' name='rbAbuse_15' className='add-only' value='Abuse_15' /> Oxycontin
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAbuse_16' name='rbAbuse_16' className='add-only' value='Abuse_16' /> None
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Legal Hx: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='rbLegal_1' name='rbLegal_1' className='add-only' value='Legal_1' /> Violation of probation
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLegal_2' name='rbLegal_2' className='add-only' value='Legal_2' /> Unruly child
                        </td>
                        <td className='w-100'>
                            <input type='checkbox' id='rbLegal_3' name='rbLegal_3' className='add-only' value='Legal_3' /> Runaway
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='rbLegal_4' name='rbLegal_4' className='add-only' value='Legal_4' /> Drug possession
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLegal_5' name='rbLegal_5' className='add-only' value='Legal_5' /> Selling drugs
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLegal_6' name='rbLegal_6' className='add-only' value='Legal_6' /> Battery
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLegal_7' name='rbLegal_7' className='add-only' value='Legal_7' /> Assault
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLegal_8' name='rbLegal_8' className='add-only' value='Legal_8' /> Burglary/theft
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLegal_9' name='rbLegal_9' className='add-only' value='Legal_9' /> Probation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='checkbox' id='rbLegal_10' name='rbLegal_10' className='add-only' value='Legal_10' /> School disruption
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLegal_11' name='rbLegal_11' className='add-only' value='Legal_11' /> Trespass
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLegal_12' name='rbLegal_12' className='add-only' value='Legal_12' /> Truancy
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbLegal_13' name='rbLegal_13' className='add-only' value='Legal_13' /> None
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h4>
                    Mental Status Examination: (Check all items that apply)
                </h4>
                <h4>
                    Orientation:
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appearance:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAppearance_1' name='rbAppearance_1' className='add-only' value='Appearance_1' /> Neat
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAppearance_2' name='rbAppearance_2' className='add-only' value='Appearance_2' /> Fastidious
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAppearance_3' name='rbAppearance_3' className='add-only' value='Appearance_3' /> Casual
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAppearance_4' name='rbAppearance_4' className='add-only' value='Appearance_4' /> Flamboyant
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAppearance_5' name='rbAppearance_5' className='add-only' value='Appearance_5' /> Bizarre
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAppearance_6' name='rbAppearance_6' className='add-only' value='Appearance_6' /> Disheveled
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Demeanor:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbDemeanor_1' name='rbDemeanor_1' className='add-only' value='Demeanor_1' /> Demanding
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbDemeanor_2' name='rbDemeanor_2' className='add-only' value='Demeanor_2' /> Fastidious
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbDemeanor_3' name='rbDemeanor_3' className='add-only' value='Demeanor_3' /> Friendly
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbDemeanor_4' name='rbDemeanor_4' className='add-only' value='Demeanor_4' /> Hostile
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbDemeanor_5' name='rbDemeanor_5' className='add-only' value='Demeanor_5' /> Manipulative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbDemeanor_6' name='rbDemeanor_6' className='add-only' value='Demeanor_6' /> Negative
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbDemeanor_7' name='rbDemeanor_7' className='add-only' value='Demeanor_7' /> Aloof
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Movement:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbMovement_1' name='rbMovement_1' className='add-only' value='Movement_1' /> Euthymic
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbMovement_2' name='rbMovement_2' className='add-only' value='Movement_2' /> Elevated
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbMovement_3' name='rbMovement_3' className='add-only' value='Movement_3' /> Dysphoric
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbMovement_4' name='rbMovement_4' className='add-only' value='Movement_4' /> Tics
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbMovement_5' name='rbMovement_5' className='add-only' value='Movement_5' /> tremors
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAffect_1' name='rbAffect_1' className='add-only' value='Affect_1' /> Full range
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAffect_2' name='rbAffect_2' className='add-only' value='Affect_2' /> Constricted
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAffect_3' name='rbAffect_3' className='add-only' value='Affect_3' /> Labile
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAffect_4' name='rbAffect_4' className='add-only' value='Affect_4' /> Irritable
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAffect_5' name='rbAffect_5' className='add-only' value='Affect_5' /> Blunted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbAffect_6' name='rbAffect_6' className='add-only' value='Affect_6' /> Flat
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbSpeech_1' name='rbSpeech_1' className='add-only' value='Speech_1' /> WNL
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbSpeech_2' name='rbSpeech_2' className='add-only' value='Speech_2' /> Hyperverbal
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='rbSpeech_3' name='rbSpeech_3' className='add-only' value='Speech_3' /> Pressure speech
                        </td>
                        <td className='w-100'>
                            <input type='checkbox' id='rbSpeech_4' name='rbSpeech_4' className='add-only' value='Speech_4' /> Slow
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbSpeech_5' name='rbSpeech_5' className='add-only' value='Speech_5' /> Soft
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbSpeech_6' name='rbSpeech_6' className='add-only' value='Speech_6' /> Loud
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Processes:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbThought_1' name='rbThought_1' className='add-only' value='Thought_1' /> Goal directed
                        </td>
                        <td className='w-100'>
                            <input type='checkbox' id='rbThought_2' name='rbThought_2' className='add-only' value='Thought_2' /> FOI
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbThought_3' name='rbThought_3' className='add-only' value='Thought_3' /> Tangential
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbThought_4' name='rbThought_4' className='add-only' value='Thought_4' /> Circumstantial
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='rbThought_5' name='rbThought_5' className='add-only' value='Thought_5' /> Racing thoughts
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbThought_6' name='rbThought_6' className='add-only' value='Thought_6' /> Blocking
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbThought_7' name='rbThought_7' className='add-only' value='Thought_7' /> Perseveration
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Content: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbContent_1' name='rbContent_1' className='add-only' value='Content_1' /> Delusions
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbContent_2' name='rbContent_2' className='add-only' value='Content_2' /> Obsessions
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbContent_3' name='rbContent_3' className='add-only' value='Content_3' /> Compulsions
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='rbContent_4' name='rbContent_4' className='add-only' value='Content_4' /> Ideas of reference
                        </td>
                        <td className='w-100'>
                            <input type='checkbox' id='rbContent_5' name='rbContent_5' className='add-only' value='Content_5' /> Phobia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbContent_6' name='rbContent_6' className='add-only' value='Content_6' /> AH
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbContent_7' name='rbContent_7' className='add-only' value='Content_7' /> VH
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insight/Judgment: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='rbInsight_1' name='rbInsight_1' className='add-only' value='Insight_1' /> Good
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbInsight_2' name='rbInsight_2' className='add-only' value='Insight_2' /> Fair
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbInsight_3' name='rbInsight_3' className='add-only' value='Insight_3' /> Poor
                        </td>
                        <td className='w-200'>
                            &nbsp;
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Reliability of Information:  </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbReliability_1' name='rbReliability_1' className='add-only' value='Reliability_1' /> Very Good
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbReliability_2' name='rbReliability_2' className='add-only' value='Reliability_2' /> Good
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbReliability_3' name='rbReliability_3' className='add-only' value='Reliability_3' /> Fair
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbReliability_4' name='rbReliability_4' className='add-only' value='Reliability_4' /> Poor
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h4>
                    Diagnosis:
                </h4>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>CODE:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>NAME:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCode_1' name='txtCode_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtName_1' name='txtName' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCode_2' name='txtCode_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtName_2' name='txtName_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCode_3' name='txtCode_3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtName_3' name='txtName_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCode_4' name='txtCode_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtName_4' name='txtName_4' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Prognosis:</span> <span className='small'>(Please check)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPrognosis_1' name='rbPrognosis_1' className='add-only' value='Prognosis_1' /> Poor
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPrognosis_2' name='rbPrognosis_2' className='add-only' value='Prognosis_2' /> Fair
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPrognosis_3' name='rbPrognosis_3' className='add-only' value='Prognosis_3' /> Good
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='rbPrognosis_4' name='rbPrognosis_4' className='add-only' value='Prognosis_4' /> Excellent
                        </td>
                        <td className='w-150'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature/Title </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Please Type/Print Name and Title </td>
                    </tr>
                </table>






            </div>
        </form>

    )
}